export const patientNoteState = {
  patientNoteList: [],
  isNoteHovered: false,
  currentPatientNote: {},
  isEditPatientNote: false,
  patientNotesFocused: false,
  patientNotesExpanded: false,
  patientNotesSubmitting: false,
};
